<form [ngClass]="{'customAdmmanageExamForm' : true,  'bottom-line' : isControlDisable }" [formGroup]="form">
  <i *ngIf="showTimerIcon" class="material-icons timer">&#xE192;</i>
  <span class="customAdmmanageExamFormHrs" *ngIf="configModel.hhShow">
    <input mdInput placeholder="hh" formControlName="hh" type="number" [max]= "configModel.hhMax" [min]="configModel.hhMin"  (blur)= "onBlur()"
    [min-max-input]="{formControl:form.controls.hh, minValue:configModel.hhMin, maxValue:configModel.hhMax}">
  </span>

  <span class="customAdmmanageExamFormMin" *ngIf="configModel.mmShow">
    <input mdInput placeholder="mm" formControlName="mm" type="number" [max]= "configModel.mmMax" [min]="configModel.mmMin" (blur)= "onBlur()"
    [min-max-input]="{formControl:form.controls.mm, minValue:configModel.mmMin, maxValue:configModel.mmMax}">
  </span>

  <span class="customAdmmanageExamFormSec" *ngIf="configModel.ssShow">
    <input mdInput placeholder="ss" formControlName="ss" type="number" [max]= "configModel.ssMax" [min]="configModel.ssMin" (blur)= "onBlur()"
    [min-max-input]="{formControl:form.controls.ss, minValue:configModel.ssMin, maxValue:configModel.ssMax}">
  </span>

  <span *ngIf="configModel.format == 12" class="formatcls">
    <md-select formControlName="format">
      <md-option *ngFor="let option of dateFormatOptions" [value]="option">
        {{ option }}
      </md-option>
    </md-select>
  </span>

</form>


// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/custom-time-control/custom-time-control.component.html